module.exports = __webpack_public_path__ + "cdb2c3b70aeae84548bd5c86aa6c6b9d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-96.png
// module id = 155
// module chunks = 0